module.exports = __webpack_public_path__ + "6c473f12474493dad24eb0186ef16c0c.png";